import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useTrackingPage } from '../../components/tracking/trackingProvider';
import EventCreationForm from './eventCreationForm';
import EventCreationStepSideBar from './eventCreationStepSideBar';

import Styles from '../../styles/eventCreation/eventCreation.module.css';

export default function EventCreation({ organization, organizationInfos }) {
    const { t } = useTranslation();

    const stepLabels = {
        0: t('ticket.creationEvent.stepSideBar.stepInfos'),
        1: t('ticket.creationEvent.stepSideBar.stepLocalization'),
        2: t('ticket.creationEvent.stepSideBar.stepDates'),
        3: t('ticket.creationEvent.stepSideBar.stepRates')
    };

    const [steps, setSteps] = useState({
        0: 'open',
        1: 'closed',
        2: 'closed',
        3: 'closed'
    });

    const scrollTop = React.useCallback(() => {
        if (document.body.clientWidth < 800) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, []);

    useTrackingPage('VIEW - CREATE EVENT', { 'Page Title': 'CREATE EVENT' });

    return (
        <>
            <div className={Styles['event-creation-flex']}>
                <EventCreationStepSideBar steps={steps} labels={stepLabels} organization={organization} organizationInfos={organizationInfos} />
                <div className={Styles['event-creation-container']}>
                    <EventCreationForm organization={organization} steps={steps} onChangeSteps={setSteps} organizationInfos={organizationInfos} scrollTop={scrollTop} />
                </div>
            </div>
        </>
    );
}

EventCreation.propTypes = {
    organization: PropTypes.object.isRequired,
    organizationInfos: PropTypes.object.isRequired
};
